export const indentFilters = [
  { id: -1, name: 'All Indents' },
  { id: 1, name: 'Clean Indents' },
  { id: 2, name: 'Non Clean Indents' },
  { id: 3, name: 'Aged Indents', age_filter: true },
];

export const deliveryTypes = [
  { id: -1, name: 'All delivery types' },
  { id: 1, name: 'FTL' },
  { id: 2, name: 'PTL' },
];

export const invoiceFilters = [
  { id: -1, name: 'All Invoices' },
  { id: 1, name: 'Clean Invoices' },
  { id: 2, name: 'Non Clean Invoices' },
  { id: 3, name: 'Aged Invoices', age_filter: true },
];

export const discountStatus = [
  { id: -1, name: 'All' },
  { id: 1, name: 'Discounted' },
  { id: 2, name: 'Undiscounted' },
];

export const vehicleTypes = [
  { id: -1, name: 'All vehicles' },
  { id: 1, name: 'FTL' },
  { id: 2, name: 'PTL' },
];

export const movementTypes = [
  { id: -1, name: 'All movement Types' },
  { id: 1, name: 'Secondary', icon: 'secondary' },
  { id: 2, name: 'Primary', icon: 'primary' },
  { id: 3, name: 'Vendor', icon: 'status_vendor' },
  { id: 4, name: 'Returns', icon: 'status_return' },
];

export const gstTypes = [
  { id: -1, name: 'All GST types' },
  { id: 1, name: 'FCM' },
  { id: 2, name: 'RCM' },
];

export const gstMethods = [
  { id: 1, name: 'Forward' },
  { id: 2, name: 'Reverse' },
];

export const taxTypes = [
  { id: 1, name: 'Tax', value: true },
  { id: 2, name: 'No Tax', value: false },
];

export const dateFilterTypes = [
  { id: 1, name: 'Delivery Date', value: 'delivery_date', invokeDateFilterEvent: true },
  { id: 2, name: 'Indent Created Date', value: 'indent_created_date', invokeDateFilterEvent: true },
];

export const statusFilters = [
  { id: 7, name: 'Delivered', color: 'green' },
  { id: 8, name: 'Cancelled', color: 'red' },
  { id: 40, name: 'Not Delivered', color: 'red', feature: 'indent_not_delivered' },
];

export const enabledPayInDispatchStatusFilters = [
  { id: 6, name: 'Dispatched', color: 'blue' },
  { id: 7, name: 'Delivered', color: 'green' },
  { id: 8, name: 'Cancelled', color: 'red' },
];

export const filters = {
  CLIENT: 'Client',
  DEPOT: 'Depot',
  DATE: 'Date',
  DATE_PICKER: 'Date Picker',
  CREATION_DATE: 'Creation Date',
  UPDATION_DATE: 'Updation Date',
  INVOICE_TYPE: 'Invoice Type',
  DISCOUNT_STATUS: 'Discount Status',
  INDENT_TYPE: 'Indent Type',
  DELIVERY_TYPE: 'Delivery Type',
  GST_TYPE: 'GST Type',
  STATUS: 'Status',
  TAX: 'Tax',
  DATE_FILTER_TYPE: 'Date Filter Type',
  LEGAL_ENTITY: 'Legal Entity',
  PANDO_LEGAL_ENTITY: 'Pando Legal Entity',
  MOVEMENT: 'Movement',
  CUSTOM_STATUS: 'Custom Status',
  BILL_TO_PARTY: 'Bill to Party',
};

export const freightBillFilters = {
  CATEGORY: 'Category',
};

export const WalletFilters = {
  DATE: 'Date',
  DEPOT: 'Depot',
  CLIENT: 'Client',
  STATUS: 'Status',
  REASON: 'Reason',
};

export const Menu = [{
  id: 'payments',
  name: 'Ready for Billing',
  feature: 'ready_for_billing',
},
{
  id: 'freightBill',
  name: 'Freight Bill',
  feature: 'freight_bill',
},
{
  id: 'invoices',
  name: 'Invoices',
  feature: '',
},
{
  id: 'Wallet-v2',
  name: 'Wallet',
  feature: 'wallet_v2',
}];

export const displayOptions = [{
  id: 0,
  label: 'Indent ID',
  tlabel: 'INVOICE_SEARCH_INDENT_ID',
}, {
  id: 1,
  label: 'Truck Type',
  hide_option_config: 'hide_transporter_truck_type',
  tlabel: 'INVOICE_TRUCK_TYPE',
}, {
  id: 2,
  label: 'Shipment ID',
  tlabel: 'INVOICE_SHIPMENT_ID',
}];

// transporter side invoice statuses
export const status = [
  { id: -1, name: 'All Statuses' },
  { id: 1, name: 'Generated', ids: [1], groupId: 1001, color: 'purple' },
  { id: 2, name: 'Approved', ids: [3, 6], groupId: 1002, color: 'teal' },
  { id: 3, name: 'Returned', ids: [4], groupId: 1003, color: 'red' },
  { id: 4, name: 'Re-submitted', ids: [5], groupId: 1004, color: 'yellow' },
  { id: 5, name: 'Paid', ids: [7], groupId: 1005, color: 'green' },
  { id: 6, name: 'Checked', ids: [2], groupId: 1007, color: 'blue' },
  { id: 8, name: 'Rejected', ids: [8], groupId: 1008, color: 'red' },
  { id: 9, name: 'On-Hold', ids: [9], groupId: 1009, color: 'orange' },
  { id: 10, name: 'Cancelled', ids: [10], groupId: 1006, color: 'red' },
  { id: 11, name: 'Partial', ids: [12], groupId: 1010, color: 'orange' },
];

export const paymentsButtons = [
  { id: 1, name: 'Download', emitMethod: 'downloadExcel', show: true, class: 'header_sbtn', disabled: false, disableTooltip: 'PTL and FTL Indents can only be downloaded separately' },
  { id: 2, name: 'Create Invoice', emitMethod: 'createInvoice', show: true, class: 'header_pbtn', disabled: false, routerLinkName: 'IndentDetails' },
  { id: 3, name: 'Add to Invoice', emitMethod: 'addToInvoice', show: false, class: 'header_pbtn', disabled: false },
];

export const invoicesButtons = [
  { id: 1, name: 'Export', emitMethod: 'export', show: true, class: 'header_sbtn', disabled: false },
];

export const freightBillButtons = [
  { id: 2, name: 'Create FreightBill', emitMethod: 'freightBill', show: true, class: 'header_pbtn', disabled: false, routerLinkName: 'IndentDetails' }];

export const WalletButtons = [
  { id: 1, name: 'Export', emitMethod: 'exportWallet', show: true, class: 'header_sbtn', disabled: false },
];

export const PaymentHeader = [
  {
    head: 'Indent ID',
    label: 'indentId',
    truncateOn: 22,
    class: 'wp15',
    subDetail: {
      label: 'indentCreatedDate',
    },
    tlabel: 'PAY_INDENT_ID',
  },
  {
    head: 'Status',
    label: 'status',
    truncateOn: 12,
    class: 'wp10',
    tlabel: 'PAY_STATUS',
  },
  {
    head: 'Delivered Date',
    label: 'deliveryDate',
    truncateOn: 12,
    class: 'wp15',
    tlabel: 'PAY_DELIVERED_DATE',
  },
  {
    head: 'Route',
    label: 'route',
    truncateOn: 25,
    class: 'wp15',
    tooltip: true,
    tlabel: 'PAY_ROUTE',
  },
  {
    head: 'Vehicle Type',
    label: 'vehicleName',
    truncateOn: 20,
    class: 'wp15',
    hide_header_config: 'hide_transporter_truck_type',
    tlabel: 'PAY_VEHICLE_TYPE',
  },
  // Commenting the below intentionally as per ticket PAN-11033. Need to be reverted when requested
  // {
  //   head: 'Age (in days)',
  //   label: 'age',
  //   truncateOn: 20,
  //   headerTooltip: 'Age of the Indent from Delivery',
  //   class: 'wp15',
  // }
];

export const InvoiceHeader = [
  {
    head: 'Invoice No',
    label: 'invoiceId',
    truncateOn: 28,
    selected: true,
    class: 'wp20',
    tlabel: 'INVOICE_INVOICE_NO',
  },
  {
    head: 'Status',
    label: 'status',
    selected: true,
    class: 'wp10',
    tlabel: 'INVOICE_STATUS',
  },
  {
    head: 'Date',
    label: 'date',
    truncateOn: 15,
    selected: false,
    class: 'wp10',
    tlabel: 'INVOICE_DATE',
  },
  {
    head: 'Amount',
    label: 'amount',
    selected: true,
    class: 'wp10',
    tlabel: 'INVOICE_AMOUNT',
  },
  {
    head: 'Age (in days)',
    label: 'age',
    truncateOn: 10,
    selected: true,
    headerTooltip: 'Age of the Invoice',
    class: 'wp10',
    tlabel: 'INVOICE_AGE',
  },
  {
    label: 'payment_due_date',
    class: 'wp15',
    head: 'Payment Due Date',
    selected: true,
    tlabel: 'INVOICE_PAYMENT_DUE_DATE',
  }];

export const FreightBillHeader = [
  {
    title: 'Bill No',
    label: 'bill_no',
    truncateOn: 20,
    show: true,
    colSpan: 4,
    tlabel: 'BILL_NO',
  },
  {
    title: 'No of Indents',
    label: 'indents_count',
    show: true,
    colSpan: 2,
    tlabel: 'NO_OF_INDENTS',
  },
  {
    title: 'Category',
    label: 'category',
    show: true,
    colSpan: 3,
    tlabel: 'CATEGORY',
  }];

export const SummaryHeaderLabels = [
  { label: 'invoiceNumber', head: 'Invoice Number', tlabel: 'INVOICE_NUMBER', editableField: true, invoiceEditable: true, required: true, maxLength: 16 },
  { label: 'proformaInvoiceNumber', feature: 'auto_generate_proforma_invoice_number', head: 'Proforma Invoice Number', tlabel: 'PROFORMA_INVOICE_NUMBER', invoiceEditable: false },
  { label: 'irnNumber', head: 'IRN Number', tlabel: 'IRN_NUMBER', editableField: true, invoiceEditable: true, required: false, maxLength: 64 },
  { label: 'invoiceDate', head: 'Invoice date', tlabel: 'INVOICE_DATE', editableField: true, type: 'date', invoiceEditable: true },
  { label: 'serviceReciepentState', head: 'PLACE OF SUPPLY', tlabel: 'PLACE_OF_SUPPLY', invoiceEditable: false },
  { label: 'isTaxReverseChargePayable', head: 'Tax payable on reverse charge', tlabel: 'TAX_PAYABLE_REVERSE_CHARGE', invoiceEditable: false },
  { label: 'hsnSac', head: 'HSN/SAC', tlabel: 'HSN_SAC', editableField: true, type: 'dropdown', invoiceEditable: true },
  { label: 'poNumber', head: 'PO Number', tlabel: 'PO_NUMBER', editableField: false, invoiceEditable: false },
  { label: 'billToParty', head: 'Bill to Party', tlabel: 'BILL_TO_PARTY', editableField: true, type: 'dropdown', invoiceEditable: false },
];


export const BillToPartyValues = [
  { id: 2, label: 'Source Depot', value: 'Source Depot' },
  { id: 3, label: 'Destination Depot', value: 'Destination Depot' },
  { id: 1, label: 'Central HO', value: 'Central HO' },
];

export const movementType = {
  SECONDARY: 1,
  PRIMARY: 2,
  INWARD: 3,
  RETURNS: 4,
};

export const invoiceStatus = {
  CUSTOM: 0,
  GENERATED: 1,
  CHECKED: 2,
  APPROVED: 3,
  RETURNED: 4,
  RE_SUBMITTED: 5,
  POSTED: 6,
  REJECTED: 8,
};

export const SummaryHeaderLabelsFreightBill = [
  { label: 'billNumber', head: 'Bill Number', editableField: false, tlabel: 'BILL_NUMBER' },
  { label: 'billDate', head: 'Bill date', editableField: true, type: 'date', tlabel: 'BILL_DATE' },
  { label: 'shipmentId', head: 'Shipment ID', editableField: false, tlabel: 'INVOICE_SHIPMENT_ID' },
];

export const WalletHeader = [
  { label: 'indent_id', class: 'wp10', head: 'Indent ID', tlabel: 'WALLET_INDENT_ID' },
  { label: 'status', class: 'wp10', head: 'Status', tlabel: 'WALLET_STATUS' },
  { label: 'client_name', class: 'wp15', head: 'Client', truncateOn: 20, tlabel: 'WALLET_CLIENT' },
  // { label: 'indent_id', class: 'wp15', head: 'Indent #' },
  { label: 'route', class: 'wp15', head: 'Route', tooltip: true, tlabel: 'WALLET_ROUTE' },
  { label: 'shipment_number', class: 'wp10', head: 'Shipment No', tlabel: 'WALLET_SHIPMENT_NUMBER' },
  { label: 'reason', class: 'wp10', head: 'Reason', tlabel: 'WALLET_REASON' },
  { label: 'amount', class: 'wp10', head: 'Amount', tlabel: 'WALLET_AMOUNT' },
  { label: 'reference_number', class: 'wp10', head: 'Reference Number', tlabel: 'REFERENCE_NUMBER' },
];

export const invoiceSearchParameters = [
  {
    id: 1,
    name: 'invoice number',
    query: 'invoice_number',
    tname: 'INVOICE_SEARCH_INVOICE_NUMBER',
    allowBackSlash: true,
  },
  {
    id: 2,
    name: 'proforma invoice number',
    query: 'proforma_invoice_number',
    tname: 'INVOICE_SEARCH_PROFORMA_INVOICE_NUMBER',
    feature: 'auto_generate_proforma_invoice_number',
  },
  {
    id: 3,
    name: 'indent id',
    query: 'order_no',
    tname: 'INVOICE_SEARCH_INDENT_ID',
  },
  {
    id: 4,
    name: 'lr number',
    query: 'lr_number',
    tname: 'INVOICE_SEARCH_LR_NUMBER',
  },
  {
    id: 5,
    name: 'po number',
    query: 'po_number',
    tname: 'INVOICE_SEARCH_PO_NUMBER',
  },
  {
    id: 6,
    name: 'account assignment no.',
    query: 'account_assignment_number',
    tname: 'INVOICE_SEARCH_ACCOUNT_ASSN_NO',
  },
  {
    id: 7,
    name: 'shipment number',
    query: 'shipment_number',
    tname: 'INVOICE_SEARCH_SHIPMENT_NO',
  },
];

export const freightBillSearchParameters = [
  {
    id: 1,
    name: 'Indent id',
    query: 'order_no',
    tname: 'INVOICE_SEARCH_INDENT_ID',
  },
];

export const paymentSearchParameters = [
  {
    id: 1,
    name: 'indent id',
    query: 'order_no',
    tname: 'INVOICE_SEARCH_INDENT_ID',
  },
  {
    id: 2,
    name: 'lr number',
    query: 'lr_number',
    tname: 'INVOICE_SEARCH_LR_NUMBER',
  },
  {
    id: 3,
    name: 'po number',
    query: 'po_number',
    tname: 'INVOICE_SEARCH_PO_NUMBER',
  },
  {
    id: 4,
    name: 'account assignment no.',
    query: 'account_assignment_number',
    tname: 'INVOICE_SEARCH_ACCOUNT_ASSN_NO',
  },
  {
    id: 5,
    name: 'drop off consignee',
    query: 'destination_consignee',
    tname: 'INDENT_DROP_OFF_CONSIGNEE',
    placeholder: ' Consignee Name, Ref ID or Material Invoice Number',
    tplaceholder: 'INDENT_CONSIGNEE_NAME_REF_ID',
    currentQuerySelected: 'destination_consignee_name',
    multiDropDownQueryOptions: [
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Consignee Name',
        tname: 'INDENT_CONSIGNEE_NAME',
        query: 'destination_consignee_name',
      },
      {
        label: 'in Ref id',
        tlabel: 'INDENT_IN_REF_ID',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        name: 'Consignee Ref id',
        tname: 'INDENT_CONSIGNEE_REF_ID',
        query: 'destination_consignee_refId',
      },
    ],
  },
  {
    id: 6,
    name: 'drop off depot',
    query: 'destination_depot', 
    tname: 'INDENT_DROP_OFF_DEPOT',
    placeholder: 'Depot Name or Ref ID',
    tplaceholder: 'INDENT_DEPOT_NAME_REF_ID',
    currentQuerySelected: 'destination_depot_name',
    multiDropDownQueryOptions: [
      {
        label: 'in Name',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        tlabel: 'INDENT_IN_NAME',
        name: 'Drop off depot Name',
        tname: 'INDENT_DROP_OFF_DEPOT_NAME',
        query: 'destination_depot_name',
      },
      {
        label: 'in Ref id',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        tlabel: 'INDENT_IN_REF_ID',
        name: 'Drop off depot Ref id',
        tname: 'INDENT_DROP_OFF_DEPOT_REF_ID',
        query: 'destination_depot_refId',
      },
    ],
  },
  {
    id: 7,
    name: 'vehicle number',
    query: 'vehicle_number',
    tname: 'INDENT_VEHICLE_NUMBER',
  },
];

export const walletSearchParameters = [
  {
    id: 1,
    name: 'indent id',
    query: 'order_no',
    tname: 'WALLET_SEARCH_INDENT_ID',
  },
  {
    id: 2,
    name: 'Shipment number',
    query: 'shipment_number',
    tname: 'WALLET_SEARCH_SHIPMENT_NUMBER',
  },
];

export const indentSearchParameters = [
  {
    id: 1,
    name: 'indent number',
    query: 'indent_number',
    tname: 'INVOICE_SEARCH_INDENT_NUMBER',
  },
  {
    id: 2,
    name: 'shipment number',
    query: 'shipment_number',
    tname: 'INVOICE_SEARCH_SHIPMENT_NO',
  },
  {
    id: 3,
    name: 'lr number',
    query: 'lr_number',
    tname: 'INVOICE_SEARCH_LR_NUMBER',
  },
];

export const daysInMillis = 24 * 60 * 60 * 1000;
export const defaultDateRange = {
  pastDay: 30,
  futureDay: 0,
};

export const alerts = {
  ALERT_RED: { alertClass: 'alert-list alert-red', detailsClass: 'action-red' },
  ALERT_GREEN: { alertClass: 'alert-list alert-green', detailsClass: 'action-green' },
};

export const defaultLEFilter = [
  { id: -1, name: 'Default', value: '' },
];

export const confirmationMessage = {
  createInvoice: 'Are you sure you want to generate the invoice?',
  reSubmitInvoice: 'Are you sure you want to resubmit the invoice?',
};

export const REMOVE_PAYMENT_STEPS = [
  { label: 'Queuing removal request' },
  { label: 'Unlinking payments from invoice' },
  { label: 'Recalculating invoice charges' },
  { label: 'Updating invoice' },
];

export const ADD_PAYMENT_STEPS = [
  { label: 'Queuing add request' },
  { label: 'Validating payments' },
  { label: 'Linking payments to invoice' },
  { label: 'Recalculating and updating invoice' },
];

